export default interface AnalyticsData {
  hasData: boolean;
  nActivePlayers: number;
  sumOfReceipts: number;
  nCTAs: number;
  newPlayers: number;
  nWinners: number;
  nLosers: number;
  nRedeemed: number;
  nGamePlayed: number;
  nGameOfChancePlayed: number;
  nGameWon: number;
  nRecurringPlayers: number;
  potentialRevenueFromReferredCustomers: number;
  potentialRevenueFromExistingCustomers: number;
  nShareAndWordOfMouth: number;
  distributionOfCTAs: Distribution[];
  distributionOfGameTypes: Distribution[];
  distributionOfSponsoreesCTAs: Distribution[];
  distributionOfActivePlayersBySource: Distribution[];
  giftsPerformance: GiftPerformance[];
  virality: Virality;
  redeemedBySponsorees: ReferredCustomer;
  redeemedByWordOfMouth: ReferredCustomer;

  avgBasketMultiplier: number;

  nConfigs: number;

  nAuthenticatedSponsoree: number;
  distributionOfGameAndMLParticipation: Distribution[];
  nWordOfMouth: number;
  distributionOfCTAsForSponsoree: Distribution[];
  distributionOfRepeatBusiness: Distribution[];
  distributionOfActiveSponsoredPlayersBySource: Distribution[];
  distributionShareAndWOM: Distribution[];
  boostingValue: MonthlyStatsI | null;
  totalBoostValue: number;
  boostValueWithoutRedemption: number;
  distributionOfRepeatBusinessInCurrency: Distribution[];

  explanation?: Record<
    keyof Omit<AnalyticsData, "explanation">,
    FieldExplanation
  >;
}

export interface FieldExplanation {
  name: {
    en: string;
    fr: string;
  };
  description: {
    en: string;
    fr: string;
  };
}

export interface ReferredCustomer {
  count: number;
  turnover: number;
}

export interface Virality {
  nSponsorees: number;
  nSponsoreesCTAs: number;
  nDriveToStore: number;
}

export interface GiftPerformance {
  name: string;
  image: string;
  nWon: number;
  nRedeemed: number;
}

export interface Distribution {
  _id: string;
  count: number;
}

export const AVG_BASKET_MULTIPLIER = 1.5;
export const DEFAULT_AVG_BASKET = 1500;

export const DEFAULT_ANALYTICS_DATA: AnalyticsData = {
  hasData: false,
  nActivePlayers: 0,
  nGamePlayed: 0,
  nGameOfChancePlayed: 0,
  nGameWon: 0,
  sumOfReceipts: 0,
  nCTAs: 0,
  newPlayers: 0,
  nRecurringPlayers: 0,
  nWinners: 0,
  nLosers: 0,
  nRedeemed: 0,
  nShareAndWordOfMouth: 0,
  potentialRevenueFromReferredCustomers: 0,
  potentialRevenueFromExistingCustomers: 0,
  distributionOfCTAs: [],
  distributionOfGameTypes: [],
  distributionOfSponsoreesCTAs: [],
  distributionOfActivePlayersBySource: [],
  giftsPerformance: [],
  virality: {
    nSponsorees: 0,
    nSponsoreesCTAs: 0,
    nDriveToStore: 0
  },
  redeemedByWordOfMouth: {
    count: 0,
    turnover: 0
  },
  redeemedBySponsorees: {
    count: 0,
    turnover: 0
  },
  avgBasketMultiplier: AVG_BASKET_MULTIPLIER,
  nConfigs: 0,
  nAuthenticatedSponsoree: 0,
  distributionOfGameAndMLParticipation: [],
  nWordOfMouth: 0,
  distributionOfCTAsForSponsoree: [],
  distributionOfRepeatBusiness: [],
  distributionOfActiveSponsoredPlayersBySource: [],
  distributionShareAndWOM: [],
  boostingValue: null,
  totalBoostValue: 0,
  boostValueWithoutRedemption: 0,
  distributionOfRepeatBusinessInCurrency: []
};

export interface MonthlyStatsI {
  nCTAGoogle: number;
  nCTAFacebook: number;
  nCTAInstagram: number;

  nCollectedEmail: number;
  nCollectedPhone: number;
  nCollectedBirthday: number;

  sumOfReceipts: number;
  nRedeem: number;
  nSponsoredCus: number;
  avgBasketMultiplier?: number;
  nAuthenticatedSponsoree?: number;

  nCTACheckin: number;
}
